import { advancedDebugEnabled } from "#nuxt-easy-texts/settings";
export const DEBUG_START = "\u2063";
export const DEBUG_END = "\u2060";
export function encodeKeyToInvisible(key) {
  const bits = [...key].map((char) => char.charCodeAt(0).toString(2).padStart(8, "0")).join("");
  const encoded = bits.replace(/0/g, "\u200B").replace(/1/g, "\u200C");
  return DEBUG_START + encoded + DEBUG_END;
}
export function toDebug(key, text, isDebug) {
  if (isDebug) {
    if (advancedDebugEnabled) {
      const hiddenKey = encodeKeyToInvisible(key);
      return hiddenKey + text;
    }
    return key;
  }
  return text;
}
